import { useNavigate } from 'react-router-dom'

export function DashboardESign() {
  const navigate = useNavigate()

  return (
    <div className='shadow-md p-6 rounded-xl lg:w-full w-11/12 h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
      <div className='w-full flex flex-col items-center'>
        <p className='font-bold text-3xl text-center'>Last Step</p>
        <div className='flex flex-col items-center gap-4 mt-4'>
          <button 
            onClick={() => navigate('/esign')}
            className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-lg text-3xl font-bold shadow-md'>
              <div className='flex flex-col items-center gap-2'>
                <p>Sign Now - Get your Money!</p>
                <p className='text-lg'>Click Here</p>
              </div>
          </button>
          <p className='p-2 rounded-lg text-3xl font-bold bg-red-500'>URGENT:</p>
          <p className='font-bold text-2xl'>Last Step for refund! Money in 24-48 hours!</p>
          <p>We have approved your SETC Packet, and are now ready for your E-Signature</p>
        </div>
      </div>
    </div>
  )
}